import { Component, Inject, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, MatSort, MatPaginator } from '@angular/material';
import { CargaMasivaService } from '../../../_core/services/carga-masiva.service';
import { animate, trigger, style, transition, state } from '@angular/animations';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DatePipe } from '@angular/common';
import { finalize } from 'rxjs/operators';
import { AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask } from 'angularfire2/storage';
import firebase from 'firebase';
import { TrabajadorService } from '../../../_core/services/trabajador.service';
import { environment } from '../../../../../../../environments/environment';

@Component({
  selector: 'm-tabla-carga-masiva',
  templateUrl: './tabla-carga-masiva.component.html',
  styleUrls: ['./tabla-carga-masiva.component.scss'],
  providers: [ DatePipe],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({display: 'none', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      // transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class TablaCargaMasivaComponent implements OnInit {

  viewLoading: boolean = false;
  usuario: string;

  expandedElement = null;
  dataExpanded = [];

  constructor(
    public dialogRef: MatDialogRef<TablaCargaMasivaComponent>,
    public ref_change : ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public cargaMasivaService: CargaMasivaService,
    public toastr: ToastrManager,
    private datePipe: DatePipe,
    private storage: AngularFireStorage,
    public trabajador_s: TrabajadorService,

  ) { }
  
  isLoading = true;
  dataSource: MatTableDataSource<any>= new MatTableDataSource([]);
  @ViewChild(MatSort) MatSort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = ['Tipo', 'Nombre', 'Estado', 'Total', 'Avance', 'Errores', 'FechaInicio', 'FechaFin', 'Descargado', 'FechaDescarga', 'Acciones'];

  searchKey = '';

  detalleCargaMasiva: Array<any> = [];
  ref: AngularFireStorageReference;
  task: AngularFireUploadTask;
  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    this.dataSource = new MatTableDataSource([]);
    this.dataSource.sort = this.MatSort;
    this.dataSource.paginator = this.paginator;
    this.cargaMasivaService.listar().subscribe((response: any) => {
      let { cargaMasiva, detalleCargaMasiva } = response;
      this.detalleCargaMasiva = detalleCargaMasiva;

      cargaMasiva = cargaMasiva.map(e => {
        e.EstadoNombre = this.getEstadoCargaMasiva(e.Estado);
        e.EstadoCss = this.getCssEstadoCargaMasiva(e.Estado);
        return e;
      });

      console.log(cargaMasiva);
      this.dataSource = new MatTableDataSource(cargaMasiva);
      this.dataSource.sort = this.MatSort;
      this.dataSource.paginator = this.paginator;
      this.searchInside_Table();
      this.isLoading = false;
    }, (error) => {
      this.isLoading = false;
    });

  }

  setExpandedElement(element) {
    this.dataExpanded = [];
    this.expandedElement = this.expandedElement === element ? null : element;
    if (this.expandedElement != null) {
      this.dataExpanded = this.detalleCargaMasiva.filter(e => e.CargaMasiva == this.expandedElement.CargaMasiva);
    }
  }

  searchInside_Table() {
    this.dataSource.filter = this.searchKey.trim().toLowerCase();
  }

  getEstadoCargaMasiva(estado) {
    let name = '';
    switch(estado) {
      case 0: name = 'Pendiente'; break;
      case 1: name = 'Cargando'; break;
      case 2: name = 'Terminado con Errores'; break;
      case 3: name = 'Terminado Exitosamente'; break;
    }
    return name;
  }

  getCssEstadoCargaMasiva(estado) {
    let name = '';
    switch(estado) {
      case 0: name = 'metal'; break;
      case 1: name = 'info'; break;
      case 2: name = 'danger'; break;
      case 3: name = 'success'; break;
    }
    return name;
  }

  getEstadoDetalleCargaMasiva(estado) {
    let name = '';
    switch(estado) {
      case 0: name = 'Pendiente'; break;
      case 1: name = 'Cargando'; break;
      case 2: name = 'Error'; break;
      case 3: name = 'Éxito'; break;
    }
    return name;
  }

  descargar(estado, cargaMasiva) {
    if(estado == 2 || estado == 3) {
      let waitToastr = this.toastr.infoToastr('Por favor espera...', 'Descargando', {
        dismiss: 'controlled',
        showCloseButton: false,
        animate: 'fade',
        progressBar: true
      });
        this.cargaMasivaService.descargar(cargaMasiva)
        .subscribe(response => {
          waitToastr.dismiss();
          if (response.ok) {
            this.cargaMasivaService.descargarBase64(response.base64, response.name);
            this.toastr.successToastr('Archivo descargado...', 'Éxito!', {
              toastTimeout: 3000,
              showCloseButton: true,
              animate: 'fade',
              progressBar: true
            });
            this.loadData();
          } else {
            this.toastr.errorToastr(response.message, 'Error!', {
              toastTimeout: 3000,
              showCloseButton: true,
              animate: 'fade',
              progressBar: true
            });
          }
        },(error) => {
          waitToastr.dismiss();
          this.toastr.errorToastr(error.message, 'Error!', {
            toastTimeout: 3000,
            showCloseButton: true,
            animate: 'fade',
            progressBar: true
          });
        });
    }
  }

  descargarDetalle(estado, detalleCargaMasiva, item, tipo) {
    if(estado == 3) {
      let waitToastr = this.toastr.infoToastr('Por favor espera...', 'Descargando', {
        dismiss: 'controlled',
        showCloseButton: false,
        animate: 'fade',
        progressBar: true
      });
      this.cargaMasivaService.descargarDetalle(detalleCargaMasiva)
        .subscribe(response => {
          waitToastr.dismiss();
          if (response.ok) {
            console.log(tipo);
            console.log(response);

            const blob: Blob = this.base64toBlob(response.base64);

            let file = new File([blob], `${item.ApellidoPaterno}_${item.ApellidoMaterno}_${item.Nombres}_${item.DNI}_${item.CodEmpresa}_C.docx`);


            if (tipo === 'Contratos') {
              this.subirArchivoFirebase(file, item);
            } else {
              this.subirArchivoFirebaseFormateria(file, item);
            }

            this.cargaMasivaService.descargarBase64(response.base64, response.name);
            this.toastr.successToastr('Archivo descargado...', 'Éxito!', {
              toastTimeout: 3000,
              showCloseButton: true,
              animate: 'fade',
              progressBar: true
            });
            this.loadData();
          } else {
            this.toastr.errorToastr(response.message, 'Error!', {
              toastTimeout: 3000,
              showCloseButton: true,
              animate: 'fade',
              progressBar: true
            });
          }
        },(error) => {
          waitToastr.dismiss();
          this.toastr.errorToastr(error.message, 'Error!', {
            toastTimeout: 3000,
            showCloseButton: true,
            animate: 'fade',
            progressBar: true
          });
        });
    }
  }

  onNoClick(): void {
		this.dialogRef.close();
  }


  private blobType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=UTF-8';
  base64toBlob(b64Data, sliceSize=512): Blob {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {type: this.blobType});
    return blob;
  }
  subirArchivoFirebase(file, postulante) {
    console.log(postulante);
    let nombreArchivo = file.name;
    let datoArchivo = nombreArchivo.split(".");
    let tipoDocumento = datoArchivo[datoArchivo.length-1];
    let filePath = '';
    
    let strNombre = postulante.ApellidoPaterno + ' ' + postulante.ApellidoMaterno + ' ' + postulante.Nombres;
    let fechaInicioContrato = this.datePipe.transform(postulante.InicioContrato,'dd-MM-yyyy');
    let carpeta = postulante.CondicionPostulante_Val === '0003' ? 'RENOVACIONES' : 'CONTRATO';
    let nombreArchivoFirebase = postulante.CondicionPostulante_Val === '0003' ? ('R - ' + strNombre + ' - ' + fechaInicioContrato + '.' + datoArchivo[datoArchivo.length - 1]) : ('C - ' + strNombre + ' - ' + fechaInicioContrato + '.' + datoArchivo[datoArchivo.length - 1]);

    // 0001	Nuevo
    // 0002	Reingresante
    // 0003	Renovación

    filePath = "ModuloAdmision/" + postulante.CodEmpresa + '/' + postulante.CodTipoTrabNombre + '/' + strNombre.substring(0,1) + '/' + strNombre + '/' + fechaInicioContrato + '/' + carpeta + '/' + nombreArchivoFirebase;

    firebase.auth().signInWithEmailAndPassword(environment.EmailFirebase, environment.PasswordFirebase)
    .then((userCredential) => {
      this.ref = this.storage.ref(filePath);
      this.task = this.ref.put(file);
      this.task.snapshotChanges().pipe(
        finalize(() => {
          this.ref.getDownloadURL().subscribe(url => { 
            let model = {
              Postulante: postulante.ValorCol2,
              UrlArchivo: url,
              Tipo: '1'
            }

            this.cargarArchivoFirebase(model);
          });
        })
      ).subscribe();
    })
    .catch((error) => {
      var errorCode = error.code;
      var errorMessage = error.message;
    });  
  }


  subirArchivoFirebaseFormateria(file, postulante) {
    let nombreArchivo = file.name;
    let datoArchivo = nombreArchivo.split(".");
    let tipoDocumento = datoArchivo[datoArchivo.length-1];
    let filePath = '';
    
    let strNombre = postulante.ApellidoPaterno + ' ' + postulante.ApellidoMaterno + ' ' + postulante.Nombres;
    let fechaInicioContrato = this.datePipe.transform(postulante.InicioContrato,'dd-MM-yyyy');
    let carpeta = 'FORMATERIA';
    let nombreArchivoFirebase = 'F - ' + strNombre + ' - ' + fechaInicioContrato + '.' + datoArchivo[datoArchivo.length - 1];


    filePath = "ModuloAdmision/" + postulante.CodEmpresa + '/' + postulante.CodTipoTrabNombre + '/' + strNombre.substring(0,1) + '/' + strNombre + '/' + fechaInicioContrato + '/' + carpeta + '/' + nombreArchivoFirebase;

    firebase.auth().signInWithEmailAndPassword(environment.EmailFirebase, environment.PasswordFirebase)
    .then((userCredential) => {
      this.ref = this.storage.ref(filePath);
      this.task = this.ref.put(file);
      this.task.snapshotChanges().pipe(
        finalize(() => {
          this.ref.getDownloadURL().subscribe(url => { 
            console.log(url);
            let model = {
              Postulante: postulante.ValorCol2,
              UrlArchivo: url,
              Tipo: '2'
            }
            this.cargarArchivoFirebase(model);
          });
        })
      ).subscribe();
    })
    .catch((error) => {
      var errorCode = error.code;
      var errorMessage = error.message;
    });  
  }

  cargarArchivoFirebase(model) {
    this.trabajador_s._SaveUrlArchivoContratos(model)
        .subscribe(response => {
          
        },(error) => {
          console.log(error);
        });
  }
}
